import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { PATH_MAP } from "../../configuration/PathMap"
import { defaultMarketingQuizSlug } from "../../configuration/MarketingQuizzes"

export const PublicMenuMarketingFooter = () => {
  const { t } = useTranslation()

  return (
    <footer className="m-4">
      <div className="mx-auto flex w-[325px] flex-col items-center gap-2 rounded-lg bg-white px-4 py-3 text-center shadow-sm sm:flex-row sm:text-left">
        <img
          src="/logo600.png"
          alt={t("publicMenu:marketing_footer.logo_alt")}
          className="h-14 w-14 shrink-0 rounded-full object-contain sm:h-16 sm:w-16"
        />

        <div className="min-w-0 flex-1">
          <p className="text-xs font-semibold text-gray-500">{t("publicMenu:marketing_footer.created_with")}</p>

          <Link
            to={PATH_MAP.LEAD_QUIZ_LINK(defaultMarketingQuizSlug)}
            className="mt-0.5 text-sm font-black leading-snug text-gray-900 sm:text-base"
            aria-label={t("publicMenu:marketing_footer.link_label")}
            data-interaction-description-key="interactionDescriptions:publicMenu.components.publicMenuMarketingFooter.link.link"
          >
            {t("publicMenu:marketing_footer.title")}
          </Link>
        </div>
      </div>
    </footer>
  )
}
